// общий helper для скачивания CSV-выгрузок реестров.
// Берёт текущие фильтры юриста (поиск, статус, сортировка...) и
// прикрепляет их к запросу — выгружается ровно то, что видно на экране.
//
// Все экспорт-эндпоинты на бэке возвращают `text/csv; charset=utf-8` с
// BOM в начале — Excel открывает кириллицу без танцев с кодировками.

export async function downloadCsv(
  endpoint: string,
  params: Record<string, string | number | undefined | null>,
  accessToken: string | null,
  fallbackName: string,
): Promise<void> {
  const base = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v == null || v === '') continue;
    usp.append(k, String(v));
  }
  const qs = usp.toString();
  const url = qs ? `${base}${endpoint}?${qs}` : `${base}${endpoint}`;

  const resp = await fetch(url, {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });
  if (!resp.ok) {
    throw new Error(`HTTP ${resp.status}`);
  }
  const blob = await resp.blob();
  const objectUrl = URL.createObjectURL(blob);
  const cd = resp.headers.get('content-disposition') ?? '';
  const match = cd.match(/filename="?([^";]+)"?/i);
  const filename = match?.[1] ?? fallbackName;
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
}
